<template>
  <div id="app" class="bg-secondary">
  <div class="alert" role="alert" id="snackbar_home">
    WELCOME MANHOLE 4 AFRICA PRODUCTION MONITORING.
  </div>
  <!-- Public routes (the emailed password-reset link) must render for a logged-out
       user; everything else falls back to the login screen. -->
  <router-view v-if="!auth && isPublicRoute"></router-view>
  <LogIn v-else-if="!auth"></LogIn>
  <Nav v-if="auth"></Nav>
  </div>
</template>

<script>
import Nav from './components/NavNew.vue'
import LogIn from './components/auth/LogIn'
export default {
components: {
  Nav: Nav,
  LogIn: LogIn
},

computed: {
  auth() {
    return this.$store.getters.loggedIn
  },

  // Routes reachable without a session (opened from an email link).
  isPublicRoute() {
    return this.$route.name === 'PassReset'
  }
}
}
</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  object-fit: cover;
}

.alert {
    width: 30%;
}

#snackbar_home {
	visibility: hidden;
	min-width: 280px;
  margin-left: -140px;
  text-align: center;
  color: var(--accent-contrast);
  background-color: var(--accent) !important;
	border-radius: 10px;
	padding: 12px 18px;
  font-weight: 600;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.4);
	position: fixed;
	z-index: 1;
	left: 50%;
  top: 16px;
	font-size: 15px;
  }
  
  #snackbar_home.show {
	visibility: visible;
	-webkit-animation: fadein 0.5s, fadeout 0.5s 2.5s;
	animation: fadein 0.5s, fadeout 0.5s 2.5s;
  }

</style>
